<template>    
    <div class="modal-mask" v-on:scroll="scrollMove($el)">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <div ref="examHeader">
                    <view-header :paperData="paperData" :actions="actions" :examineeId="examineeId"></view-header>
                </div>

                <div class="flex-grow-1">
                    <view-tab @setViewTab="setViewTab" :setTabFixed="setTabFixed"></view-tab>
                   
                    <div class="mt5" :class="setTabFixed && isAction ? 'mgt-50 mgb-60' : ''">
                        <component 
                            :is="tabType"
                            :periodPolicy="periodPolicy"
                            :summary="summary"
                            :pointPolicy="pointPolicy"
                            :badges="badges"
                        ></component>
                    </div>

                    
                </div>
            </div>
        </div>
        <router-view></router-view>
        
    </div>

</template>

<script>
/**
 * 단독 시험 나의 시험 상세 메인 컴포넌트(independent my exam view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import ViewHeader from './view/Header'
import ViewFooter from './view/Footer'
import ViewTab from './view/ViewTab'
import ViewInformation from './view/Information'
import ViewReward from './view/Reward'

export default {
    data() {
        return {
            examineeId: null,
            paperData: null,
            tabType: 'Information',
            setTabFixed: false,

            periodPolicy: null,
            summary: '',
            pointPolicy: null,
            badges: null,

            actions: null
        }
    },
    components: {
        'view-header': ViewHeader,
        'view-footer': ViewFooter,
        'view-tab': ViewTab,
        'Information': ViewInformation,
        'Reward': ViewReward,
    },

    mounted() {
        this.examineeId = this.$route.params.examineeId
        let params = {
            examineeId: this.examineeId,
            application: false
        }

        // get examinee view information
        examApi.independentExamineeExamView(params).then((response) => {
            this.paperData = response.data.data
            
            this.periodPolicy = this.paperData.period
            this.summary =  this.paperData.summary
            this.pointPolicy = this.paperData.point
            
        })

        // get exam intro action
        examApi.examIntro(params).then((response) => {
            this.actions = response.data.data.actions
        })

        // get exam badge list
        examApi.badges(params).then((response) => {
            this.badges = response.data.data
        })
    },

    methods: {
        setViewTab(tabType) {
            
            this.tabType = tabType
        },

        // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
        scrollMove(el) {
            if (parseInt(el.scrollTop) >= parseInt(this.$refs.examHeader.offsetHeight)) {
                this.setTabFixed = true
            }else {
                this.setTabFixed = false
            }
        },
    }
}
</script>